<template>
  <div class="datenimport">
    <h2>Projektimport</h2>
    <v-row>
      <v-col>
        <input
          ref="fileUpload"
          type="file"
          accept=".csv, .xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          @input="setUploadFile"
        />
      </v-col>
      <v-col>
        <b-btn :loading="loading" :disabled="loading" @click="startImport">
          Import starten
        </b-btn>
      </v-col>
    </v-row>
    <div class="duplikate" v-if="zeigeProjektDuplikate">
      <v-row>
        <p>
          <b
            >Der Projekt-Import war erfolgreich. <br />
            Folgende Projekte existierten allerdings bereits und wurden deshalb
            nicht mit importiert:</b
          >
        </p>
      </v-row>
      <v-row>
        <ul>
          <li v-for="duplikat in projektDuplikate" :key="duplikat">
            {{ duplikat }}
          </li>
        </ul>
      </v-row>
    </div>
    <v-snackbar v-model="showSnackbar" timeout="4000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import dateiHandleMixin from '@/mixins/datei-handle-mixin';

export default {
  name: 'Datenimport',
  data() {
    return {
      projektDatei: null,
      showSnackbar: false,
      uploadSuccessful: false,
      snackbarText: '',
      loading: false,
      projektDuplikate: [],
      zeigeProjektDuplikate: false,
    };
  },
  mixins: [dateiHandleMixin],
  computed: {
    snackbarColor: function () {
      return this.uploadSuccessful ? `primary` : `red`;
    },
  },
  methods: {
    startImport() {
      if (this.projektDatei) {
        this.loading = true;
        this.dateiUpload(this.projektDatei, this.uploadCallback);
      } else {
        this.uploadSuccessful = false;
        this.snackbarText = 'Es wurde keine Datei ausgewählt';
        this.showSnackbar = true;
      }
    },
    setUploadFile(e) {
      this.projektDatei = [e.target.files[0]];
    },
    uploadCallback(response) {
      if (response.status === 201) {
        this.projektDuplikate = response.data;
        this.zeigeProjektDuplikate = true;
      } else {
        this.uploadSuccessful = response.status === 200;
        this.snackbarText = response.data;
        this.showSnackbar = true;
        this.zeigeProjektDuplikate = false;
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.duplikate {
  padding: 30px 15px;
  p {
    font-size: 16px;
  }
}
</style>